module.exports = __webpack_public_path__ + "static/media/edit_stanby.7dbd1478.svg";